
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../util.js';
import { Toast } from 'antd-mobile/lib';
import {getVerifyCode, verifyRegisterPhone,realUserMobileCaptcha} from '../../action/investmentAction.js';
import {registerAccount,getCapcha,getMobileCaptcha} from '../../action/loginAction.js';
import { protocolCode } from '../../BankCode';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';
import { goHome } from '../../common.js';
import qrCodeImg from "../../imgs/registerBg2.png";
let intervalId = null;
let requestId = '';

/*
register?enterType=Investment/InviteRegister&inviteCode=手机号
*/

class InviteRegister extends Component{
  state={
    mobileNumber: '',
    password: '',
    mobileDynamicCode: '',
    isRequestingVerifyCode: false,
    countdown: 120,
    isSelected: false,
    flag: false,
    invitationCode: this.props.location.query.inviteCode ? (/^1[0123456789]\d{9}$/.test(this.props.location.query.inviteCode) ? this.props.location.query.inviteCode : "") : window.localStorage.getItem("inviteCode"),
    invitationCodeFlag: true,
    enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
    serverCapchaCode: '',
    imageBase64: '',
    captchaCode: ''
  }

  componentWillMount() {
    // window.localStorage.setItem("inviteCode", '18679933878');
    console.log(window.localStorage.getItem("inviteCode"))
    document.title = "注册";
    if(this.props.location.query.enterType === "InviteRegister") {

    }else{
      this.setState({
        mobileNumber: window.localStorage.getItem("register_phoneNo"),
        password: window.localStorage.getItem("register_password")
      });
    }
  }
  componentDidMount(){
    this.props.dispatch(getCapcha((code, imageBase64)=>{console.log('1&&&&&&&&&&'); this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)})); 
  }
  getCapchaCodeSuccess(code, imageBase64){
    console.log('verifySuccess');
    this.setState({
      serverCapchaCode: code,
      imageBase64,
      getCapchaSuccess:true
     
    });
  }
  getCapchaCodeAgain(){
    this.setState({
      captchaCode:''
    })
    this.props.dispatch(getCapcha((code,imageBase64)=>{this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
  }
  getCapchaCodeError(msg){
    Toast.info(msg, Util.ToastTime );
    this.setState({getCapchaSuccess: false});
  }
  componentWillUnmount(){
    requestId = '';
    this.setState({
      flag: false
    });
    if(intervalId) {
      clearInterval(intervalId);
    }
  }

  handleVerify = () => {
    if(!this.state.mobileDynamicCode || !this.state.mobileNumber ){
      Toast.info('请输入完整信息', 2);
      return;
    }
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(!this.state.password){
      let toast = Toast.info('请输入密码', 2);
      return;
    }
    if(!this.state.captchaCode){
      Toast.info('请输入图形验证码', Util.ToastTime);
      return ;
    }
    if(requestId === '' || !requestId){
      Toast.info('请先申请手机验证码', 2);
      return ;
    }
    if(!this.state.isSelected){
      Toast.info('同意协议后才能注册', 2);
      return ;
    }
    if(this.state.invitationCode && !(/^1[0123456789]\d{9}$/.test(this.state.invitationCode))){
      Toast.info('用户邀请码不合规', 2);
      return ;
    }
    // if(this.state.invitationCode == this.state.mobileNumber){
    //   Toast.info('用户邀请码不能与注册的手机号一致', 2);
    //   return ;
    // }
    let verifyParam = {
      requestId : requestId,
      mobileNo : this.state.mobileNumber,
      captchaText : this.state.mobileDynamicCode,
      password: Util.encrypt(this.state.password),
      invitationCode: this.state.invitationCode ? this.state.invitationCode : ""
    }
    this.setState({
      flag: true
    })
    this.props.dispatch(registerAccount(verifyParam, ()=>{this.verifySuccess()}, (msg)=>this.verifyError(msg)));
  }

  verifySuccess = () => {
    this.setState({
      flag: false
    });
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    // if(route) {
    //   hashHistory.go(route - window.history.length);
    // }else {
    //   hashHistory.goBack();
    // }
    // setTimeout(() => {
    //   if(callback) {
    //     callback();
    //   }
    // }, 100);
    if(this.state.enterType == "InviteRegister"){
      goHome("Investment");
      // hashHistory.push({
      //   pathname: "/",
      //   state: {
      //     route: route,
      //     callback: callback
      //   },
      //   query:{
      //     enterType:"Investment"
      //   }
      // })
    }else{
      hashHistory.go(-2);
    }
  }
  verifyError = (msg) => {
    this.setState({
      flag: false
    })
    Toast.info(msg, 2);
  }
  verifyRegisterPhoneSuc = (mobileNumber) => {
    let params = {
      mobileNo: mobileNumber,
      token: this.state.serverCapchaCode,
      captchaCode: this.state.captchaCode.toUpperCase()
    }
    this.props.dispatch(getMobileCaptcha(params, (suc) =>{
      requestId = suc;
      this.makeInterval();
    }, (err) => {
      Toast.info(err.code, Util.ToastTime);
      requestId = "";
      this.setState({
        captchaCode: ""
      });
      this.getCapchaCodeAgain();
    }));

    // this.props.dispatch(getVerifyCode(mobileNumber, (requestid)=>{requestId = requestid; }));
    // let params = { mobileNo: mobileNumber }
    // this.props.dispatch(realUserMobileCaptcha(params, (requestid)=>{requestId = requestid; }));
  }

  verifyRegisterPhoneErr = (msg) => {
    Toast.info(msg, 2);
    if(intervalId)
      clearInterval(intervalId);
    intervalId = null;
    this.setState({
      isRequestingVerifyCode: false
    });
  }

  handleWaitingForVerifyDynamicCode = () => {
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(!this.state.password){
      let toast = Toast.info('请输入密码', 2);
      return;
    }
    if(!this.state.captchaCode){
      Toast.info('请输入图形验证码', 2);
      return ;
    }
    this.props.dispatch(verifyRegisterPhone({mobileNo: this.state.mobileNumber}, (mobileNumber)=>{this.verifyRegisterPhoneSuc(mobileNumber)}, (msg)=>{this.verifyRegisterPhoneErr(msg)}));
  }
  makeInterval = () => {
    let countNum = 119;
    this.setState({isRequestingVerifyCode: true, countDown: countNum}, ()=>{
      intervalId = setInterval(() => {
        countNum--;
        if(countNum < 0){
          cancelTimeOut();
          this.setState({
            isRequestingVerifyCode: false
          });
        }
        this.setState({
          countDown: countNum
        })
      }, 1000);
      const cancelTimeOut = () => {
        if(intervalId)
          clearInterval(intervalId);
        intervalId = null;
      }
    });
  }
  handleJumpToProtocol = (title) => {
    let code=protocolCode[title];
    hashHistory.push({
        pathname:'/WebView',
        state:{name:title,code:code},
        query: {code:code}
    })
  }

  changePhoneNo = (event) => {
    this.setState({
      mobileNumber: event.target.value
    });
    window.localStorage.setItem("register_phoneNo", event.target.value);
  }

  clearPhoneNo = () => {
    this.setState({
      mobileNumber: ""
    });
    window.localStorage.setItem("register_phoneNo", "");
  }

  changePassWord = (event) => {
    this.setState({
      password: event.target.value
    });
    window.localStorage.setItem("register_password", event.target.value);
  }

  clearPassWord = () => {
    this.setState({
      password: ""
    });
    window.localStorage.setItem("register_password", "");
  }

  changeCkCard = (event) => {
    this.setState({
      mobileDynamicCode: event.target.value
    });
  }

  goBack = () => {
    hashHistory.goBack();
  }

  toggleInvitation = () => {
    this.setState({
      invitationCodeFlag: !this.state.invitationCodeFlag
    });
  }
  goInvestment = () => {
    window.location.href="http://a.app.qq.com/o/simple.jsp?pkgname=com.huaxiafortune";
    // goHome("Investment");
    // hashHistory.push({
    //     pathname:'/',
    //     state:{},
    //     query: {}
    // })
  }
  goJjLogin = () => {
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    let enterType = this.props.location.query.enterType ? this.props.location.query.enterType : null;
    let invitationCode = this.state.invitationCode;
    hashHistory.push({
      pathname: "/LoginHxjj",
      query:{
        enterType:enterType,
        invitationCode:invitationCode
      },
      state: {
        route: route,
        callback: callback
      }
    })
  }
  render(){
    let { mobileNumber, password, mobileDynamicCode } = this.state;
    console.log(this.props.location.query,"locationlocationlocation")
    return (
      <div className="mainBox"> 
         
        <div className="RegisterboxContent" style={{ width:window.winWidth, height: window.winWidth*(1285/640) }}>
          <img src={qrCodeImg} alt="" style={{width:"100%",height:"100%"}}/>
        <div className='RegisterboxContentInput'>
        <div style={{height:window.winWidth*(270/640)}}></div>
          <div style={{height:window.winWidth*(80/640)}} className="regiserTitle">
            <div></div>
            <div className="registertxt">
              <span style={{ height:1 }}></span><span className="registertxtCenter">立即注册</span><span style={{ height:1 }}></span>
            </div>
            <div></div>
          </div>
          <div style={{
              width:'auto',
              height: window.winWidth*(70/640),
              marginLeft: 30,
              marginRight: 30,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 10,
              border:"1px solid rgb(72,73,176)",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90}}>手机号码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete='off' style={{WebkitFlex: 1, fontSize: '0.26rem'}} onChange={this.changePhoneNo} value={mobileNumber} type="text"  placeholder="请输入手机号码" /> 
            <img onClick={this.clearPhoneNo}  alt="" style={{height: 40, width: 40, marginRight: 0}} src={require("../../img/login_input_cancel.png")} />
           </div>
          </div>
          <div style={{
              width:'auto',
              height: window.winWidth*(70/640),
              marginTop: 7,
              marginLeft: 30,
              marginRight: 30,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 10,
              border:"1px solid rgb(72,73,176)",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90}}>登录密码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete="off" style={{WebkitFlex: 1, fontSize: '0.26rem'}} onChange={this.changePassWord} value={password} type="password"  placeholder="请输入6-8位登录密码" /> 
            <img onClick={this.clearPassWord}  alt="" style={{height: 40, width: 40, marginRight: 0}} src={require("../../img/login_input_cancel.png")} />
           </div>
          </div>
          <div style={{
              width:'auto',
              height: window.winWidth*(70/640),
              marginTop: 7,
              marginLeft: 30,
              marginRight: 30,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 10,
              border:"1px solid rgb(72,73,176)",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90}}>图形验证码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete="off" style={{width: "100%", fontSize: '0.26rem'}} value={ this.state.captchaCode } onChange={ (e) =>{ this.setState({ captchaCode: e.target.value})}} type="text"  placeholder="请输入图形验证码" /> 
            <p style={{display: "-webkit-flex", WebkitAlignItems: "center",width:75,marginRight:3}}onClick = {()=>{this.getCapchaCodeAgain()}}>
              <img style={{
                width: 63,
                height: 27,
              }} src={`data:image/png;base64,${this.state.imageBase64}`} />
            </p>
           </div>
          </div>
          <div style={{
              width:'auto',
              height: window.winWidth*(70/640),
              marginTop: 7,
              marginLeft: 30,
              marginRight: 30,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 10,
              border:"1px solid rgb(72,73,176)",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90}}>手机动态码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <div style={{WebkitFlex: 1, paddingRight: 10}}><input autocomplete="off" style={{fontSize: '0.26rem', width: "100%"}} onChange={this.changeCkCard} value={mobileDynamicCode} type="text"  placeholder="请输入手机动态码" /></div> 
            {
                this.state.isRequestingVerifyCode ? 
                <div style = {{
                  backgroundColor: '#d8dbdd',
                  height: 27,
                  borderRadius: 13,
                  paddingLeft: 10,
                  paddingRight:10,
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex",
                  marginRight: 10,
                  width: 100
                }}>
                  <span style = {{color: "#5b6370", fontSize:'0.22rem' }}>{this.state.countDown}秒后重发</span>
                </div>
                :
                <div style={{"whiteSpace": "nowrap", width: 100, textAlign: "right", paddingRight: 13}}>
                  <span  onClick = {this.handleWaitingForVerifyDynamicCode} style = {{
                    color: 'rgb(125,131,186)',
                    fontSize: '0.22rem'
                  }} >获取验证码</span>
                </div>
              }         
           </div>
          </div>
          <div style={{height: 35, paddingRight: 26, paddingLeft: 26}}>
            <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", height: "100%"}}>
              <div  style={{ color: '#3a3e47', fontSize: 13, display: "-webkit-flex", WebkitAlignItems: "center",paddingLeft:5 }}> 
                <span></span>
              </div>
              <div style={{width: 120,paddingTop:2}}>
                <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "flex-end"}} onClick={this.toggleInvitation}>
                  <span style = {{color: '#3a3e47', marginLeft: 13, fontSize: 13}}>我有邀请码</span>
                  {
                    this.state.invitationCodeFlag ?
                    <img style={{width: 30, height: 30}} src={require('../../img/arrowBm2@4x.png')} />
                    :
                    <img style={{width: 30, height: 30}} src={require('../../img/arrowBm@4x.png')} />
                  }
                </div>
              </div>
            </div>
          </div>
          {
            this.state.invitationCodeFlag ?
            <div style = {{
              width:'auto',
              height: window.winWidth*(70/640),
              marginLeft: 30,
              marginRight: 30,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 10,
              border: "1px solid rgb(72,73,176)",
              display: "-webkit-flex"
            }}>
              <span style = {{color: '#3a3e47', marginLeft: 13, fontSize: 14, width: 60}}>邀请码</span>
              <div style = {{
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                WebkitFlex: 1,
                display: "-webkit-flex"
              }}>
                <input autocomplete="off" type="text" style = {{WebkitFlex: 1, fontSize: 13, display: "-webkit-flex"}} placeholder = {'(非必填) 请输入推荐人手机号码'} value = {this.state.invitationCode} onChange = {(event)=>this.setState({invitationCode: event.target.value})}/>
                <div onClick = {()=>{this.setState({invitationCode: ''})}} style={{ height: window.winWidth*(70/640)}} className="inviteCodeDiv" >
                  <img style={{marginRight: -2, width: 40, height: 40}} src={require('../../img/login_input_cancel.png')} />
                </div>
              </div>
            </div>
            :
            null
          }
          <div style = {{
              WebkitFlexDirection: 'row',
              WebkitJustifyContent: 'center', 
              marginTop: 0,
              marginLeft: 30,
              marginRight: 30,
              display: "-webkit-flex"
          }}>
            <div onClick = {()=>{this.setState({isSelected: !this.state.isSelected})}}>
            {
              this.state.isSelected ? 
              <img style={{
                height: 44,
                width: 44,
                marginRight:5,
                marginLeft: -13
              }} src={require('../../img/squareHookNew.png')} />
              :
              <img style={{
                height: 44,
                width: 44,
                marginRight:5,
                marginLeft: -13
              }} src={require('../../img/squareNew.png')} />
            }
            </div>
            <span style = {{
              marginTop: 3,
              marginLeft: -7,
              WebkitFlex: 1,
              color: '#a1a7b2',
              fontSize: 12,
              lineHeight: "20px"
            }}>我已阅读并同意<span style = {{color: 'rgb(73,80,160)'}} onClick = {()=>{this.handleJumpToProtocol('华夏财富电子交易服务协议')}}>《华夏财富电子交易服务协议》</span><span style = {{color: 'rgb(73,80,160)'}} onClick = {()=>{this.handleJumpToProtocol('投资人权益须知')}}>《投资人权益须知》</span>和<span style = {{color: 'rgb(73,80,160)'}} onClick = {()=>{this.handleJumpToProtocol('电子签名约定书')}}>《电子签名约定书》</span></span>
          </div>

          <div onClick = { this.handleVerify }
               className="registerButton_new" style={{ marginTop:8, marginLeft: 30, marginRight: 30, width:'auto', height:window.winWidth*(70/640)}}
          >
            <span>注</span><span style={{marginLeft:10}}>册</span>
          </div>
          <div className="hxjzLoginBtn" onClick={this.goJjLogin }style={{ marginTop:9, marginLeft: 30, marginRight: 30, width:'auto', height:window.winWidth*(70/640)}}>
            华夏基金账号登录
          </div>
        </div>
        </div>

        <div className="registerPageTwo" style={{width:window.winWidth, height:window.winWidth*(664/640) }}>
            
        </div>
        <div className="registerPageThree" style={{width:window.winWidth, height:window.winWidth*(500/640) }}>
            
        </div>
        <div className="registerPageFour" style={{width:window.winWidth, height:window.winWidth*(795/640) }}>
            
        </div>
        <div className="registerPageFive" style={{width:window.winWidth, height:window.winWidth*(532/640) }}>
            
        </div>
        <div className="registerPageSix" style={{width:window.winWidth, height:window.winWidth*(303/640) }}>
            
        </div>
        <div className="registerPageSeven" style={{width:window.winWidth, height:window.winWidth*(148/640) }}>
            
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(InviteRegister);


// WEBPACK FOOTER //
// ./src/components/login/InviteRegister.js